import { whithdrawTheme } from "../withdraw/theme";
export const theme = whithdrawTheme;
export const styles = {
  icon: {
    width: 20,
    height: 20
  }
}